import type { NitroFetchOptions } from 'nitropack'
import { useApiUrl } from './useApiUrl'
import { useClient } from './useClient'

export function useApiFetch<T>(url: string, options: NitroFetchOptions<'json'> = {}): Promise<T> {
  const { apiUrl } = useApiUrl()

  return useClient(apiUrl.value, url, options)
}

export function useApiGet<T>(url: string, options: NitroFetchOptions<'json'> = {}): Promise<T> {
  options.method = 'GET'

  return useApiFetch(url, options)
}

export const prepareBody = (data: any = {}, options: NitroFetchOptions<'json'> = {}) => {
  if (Object.values(data).some(item => item instanceof File)) {
    const requestData = new FormData()
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (data[key] instanceof File) {
          requestData.append(key, data[key], data[key].name)
        }
        else {
          requestData.append(key, data[key] || '')
        }
      }
    }
    if (options.method && options.method !== 'POST') {
      requestData.append('_method', options.method)
    }
    options.method = 'POST'
    options.body = requestData
  }
  else {
    options.body = JSON.stringify(data)
    const headers = {
      'Content-Type': 'application/json',
    }
    if (options.headers) {
      options.headers = Object.assign({}, headers, options.headers)
    }
    else {
      options.headers = headers
    }
  }
}

export function useApiPost<T>(url: string, data: any = {}, options: NitroFetchOptions<'json'> = {}): Promise<T> {
  options.method = 'POST'
  prepareBody(data, options)

  return useApiFetch<T>(url, options)
}

export function useApiPut<T>(url: string, data: any = {}, options: NitroFetchOptions<'json'> = {}): Promise<T> {
  options.method = 'PUT'
  prepareBody(data, options)

  return useApiFetch(url, options)
}

export function useApiPatch<T>(url: string, data: any = {}, options: NitroFetchOptions<'json'> = {}): Promise<T> {
  options.method = 'PATCH'
  prepareBody(data, options)

  return useApiFetch(url, options)
}

export function useApiDelete<T>(url: string, options: NitroFetchOptions<'json'> = {}): Promise<T> {
  options.method = 'DELETE'

  return useApiFetch(url, options)
}
